<div class="dialog-container state-dialog">
  <div class="dialog-body">
    <div class="title">{{'INDEX.VERIFICATION' | translate}}</div>
    <div class="close-btn" (click)="dialogRef.close()">
      <i class="mdi mdi-close"></i>
    </div>
    <div class="code-text">{{'INDEX.CODE_TEXT' | translate}}
      <div>{{phone | phone}}</div>
    </div>
    <div class="code-box">
      <input [(ngModel)]="code" [textMask]="{mask: verificationCodeMask, guide: false}">
      <button class="w-btn orange-btn btn-wave" (click)="sendCode(code)" [disabled]="!code || code.length != 4">
        {{'INDEX.VERIFY' | translate}}
      </button>
    </div>
    <div class="resend-btn-box">
      <button class="w-btn " (click)="resendCode()">{{'INDEX.RESEND' | translate}}</button>
    </div>
    <app-loader-lock [displayLoader]="showLoader"></app-loader-lock>
  </div>
</div>
